/**
 * Operation key type, indicates if a key is a public or private key.
 */
enum OperationKeyType {
    Public = 'public',
    Private = 'private'
  }

export default OperationKeyType;
